<template>
  <div class="radish-menu" :class="{opened: menuOpen}">
    <div class="radish-menu__trigger" @click="toggleMenu" v-if="userIsAdmin">
      <img src="../assets/radish.svg" alt="">
    </div>
    <div class="radish-menu__inner">
      <div class="radish-menu-row">
        <div class="radish-menu-item" @click="goTo('/users')">Users</div>
        <div class="radish-menu-item">nope</div>
      </div>
      <div class="radish-menu-row">
        <div class="radish-menu-item" @click="logout">nope</div>
        <div class="radish-menu-item">nope</div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      menuOpen: false
    }
  },
  methods: {
    toggleMenu () {
      this.menuOpen = !this.menuOpen
    },
    logout() {

    },
    goTo(route) {
      this.toggleMenu()
      this.$router.push(route)
    }
  },
  computed: {
    ...mapGetters([
      'userIsAdmin'
    ])
  },
}
</script>